import { FunctionComponent, ReactNode } from 'react';
import styles from './ExpandableSelectorList.module.scss';

// Props for individual selectable items in the list
interface ExpandableSelectorItemProps {
    children: ReactNode;
    onClick?: () => void; // Handler for item selection
    selected?: boolean; // Whether this item is currently selected
    disabled?: boolean; // Whether this item can be selected
    className?: string;
    onSelected?: () => void; // Callback to notify parent of selection (used for auto-closing)
}

export const ExpandableSelectorItem: FunctionComponent<ExpandableSelectorItemProps> = ({
    children,
    onClick,
    selected,
    disabled,
    className,
    onSelected
}) => {
    // Combined click handler that triggers both selection and parent notification
    const handleClick = () => {
        if (!disabled) {
            onClick?.(); // Handle the selection
            onSelected?.(); // Notify parent to close the selector
        }
    };

    return (
        <div
            className={`${styles.item} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''} ${
                className || ''
            }`}
            onClick={handleClick}
            data-selected={selected} // Used for scroll positioning
        >
            {children}
        </div>
    );
};

export default ExpandableSelectorItem;
